<template>
    <div class="banner-info3 banner-fade-in">
        <div class="banner-info3-content" ref="animate">
            <div class="title">Designed for you</div>
            <div class="desc1">Please find our rates, booking form, terms and conditions below</div>
        </div>
    </div>
</template>
<script>
export default {
    mounted() {
        this.$nextTick(() => {
            const contentElement = this.$refs.animate;
            contentElement.classList.add('animate');
        })
    }
}
</script>
<style scoped lang="scss">
@import '/style/pc/common/animate.scss';
@import '/style/pc/common/fadeIn.scss';
@import '/style/phone/header/bookNow.scss';
.banner-info3 {
    color: #09080D;
    width: 100%;
    height: 39.375rem;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    background: url('/static/img/banner/bookNow.jpg');
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    // max-width: 128rem;
    margin: 0 auto;
    margin-top:5.5rem;
    .banner-info3-content{
        opacity: 0;
        transform: translateY(100%);
    }
    .title {
        font-family: Poppins;
        font-weight: 600;
        font-size: 4rem;
        margin-bottom: 1.875rem;
        font-family: Butler;
        text-align: center;
    }
     .desc1 {
        font-size: 1.25rem;
        font-weight: 700;
    }
}
</style>